define('app/session',['app/setup','app/lib/lockr'],
function(takhfifan, navigationView, lockr) {
  var _customerIsLoggedIn = false,
      _sessionHasData = false,
      _customerData = null,
      _customerVerificationData = {verified:false};

  function localSessionIsValid(){
    //reset session by default
    var $determiner = $("#localStorageDeterminer");
    if($determiner.length && $determiner.val()){
      return false;
    }
    //local storage is not valid
    if (!Lockr || !Lockr.get('formKey') || !Lockr.get('lt')) {
      return false;
    }
    //session is expired
    if (parseInt(Lockr.get('lt'), 10) < Math.floor(Date.now() / 1000)) {
      return false;
    }
    //session must reset
    if(Lockr.get('reset')){
      return false;
    }
    return true;
  }

  function getSessionData(notNotify){
    notNotify = notNotify || false;

    $.get('/ajax/account/session').done(function (data) {
      data.cartItems = generateCart(data.cartItems);
      var lifeTime = parseInt(data.lt, 10);
      if(_.isNaN(lifeTime)){
        data.lt = Math.floor(Date.now() / 1000)
      }else {
        var halfSessionTime = Math.round(lifeTime / 2);
        data.lt = (halfSessionTime > 300 ? 300 : halfSessionTime) + Math.floor(Date.now() / 1000);
      }

      if (Lockr) {
        Lockr.flush();
        _.each(data, function(value, key){
          Lockr.set(key, data[key])
        });
      }
      if(!notNotify){
        notifySession(data);
      }
    });
  }

  function notifySession(data) {
    _sessionHasData = true;
    if (data.customer) {
      _customerIsLoggedIn = true;
      _customerData = data.customer;
      takhfifan.eventHub.trigger('customer:login', data.customer);
    }

    if(data.verification){
      _customerVerificationData = data.verification;
      takhfifan.eventHub.trigger('customer:verification', data.verification);
    }

    if (data.socialconnect) {
      takhfifan.eventHub.trigger('socialconnect', data.socialconnect);
    }

    if (data.formKey) {
      takhfifan.eventHub.trigger('formkey', data.formKey);
    }

    if(data.city){
      takhfifan.eventHub.trigger('navigation:setCity', data.city);
    }

    if (!_.isUndefined(data.hasDoubleOptInConfirmation) && !_.isNull(data.hasDoubleOptInConfirmation) && data.hasDoubleOptInConfirmation) {
      takhfifan.eventHub.trigger('newsletter:doubleOptinConfirm', data.hasDoubleOptInConfirmation);
      if(Lockr){
        Lockr.set('hasDoubleOptInConfirmation', false);
      }
    }
    else if(!_.isUndefined(data.hasDoubleOptInConfirmation) && !_.isNull(data.hasDoubleOptInConfirmation) && !data.hasDoubleOptInConfirmation) {
      takhfifan.eventHub.trigger('newsletter:doubleOptinNotConfirm', data.hasDoubleOptInConfirmation);
    }

    if(data.showMugInfo){
      takhfifan.eventHub.trigger('session:showMugInfo', data.showMugInfo);
      if(Lockr){
        Lockr.set('showMugInfo', 'hide');
      }
    }

    takhfifan.eventHub.trigger('customer:sessionAquired', data);

    if(data.cartItems){
      takhfifan.eventHub.trigger('cart', data.cartItems);
    }
    $('.menu-toggle').addClass('visible');
  }

  function generateCart(items){
    var cart = {
      'items': items,
      'quantity' : 0,
      'subtotal' : 0
    };

    if(cart.items && cart.items.length){
      var quantity = 0,
        subtotal = 0;

      for(var i=0, l=cart.items.length; i<l; i++){
        subtotal += parseInt(cart.items[i].price, 10) * parseInt(cart.items[i].quantity, 10);
        quantity += parseInt(cart.items[i].quantity, 10);
      }
      cart.quantity= quantity;
      cart.subtotal= subtotal;
    }
    return cart;
  }

  return{
    loadSession: function () {
      takhfifan.eventHub.on('session:updated', function(data) {
        if(data.cartItems){
          data.cartItems = generateCart(data.cartItems);
        }
        if (Lockr) {
          _.each(data, function(value, key){
            if(_.indexOf(['formKey', 'cartItems', 'customer'], key)){
              Lockr.set(key, data[key]);
            }
          });
        }
        notifySession(data)
      }, this);
      takhfifan.eventHub.on('session:shouldUpdate', function(){
        if(window.Lockr){
          Lockr.set('reset', 'true');
        }
      });

      if(localSessionIsValid()){
        var data = {};
        _.each(Lockr.keys(), function (key) {
          data[key] = Lockr.get(key);
        });
        notifySession(data);
      }else{
        getSessionData(false);
      }

      //reset session in next load
      var $nextDeterminer = $("#localStorageDeterminerNextRequest");
      if($nextDeterminer.length && $nextDeterminer.val()){
        Lockr.set('reset', 'true');
      }
    },
    customerIsLoggedIn: function(){
      return _customerIsLoggedIn;
    },
    getCustomerData: function () {
      return _customerData;
    },
    sessionHasData: function () {
      return _sessionHasData;
    },
    getCustomerVerificationData: function () {
      return _customerVerificationData;
    }
  }
});
